import { ObservableFromFetch } from "../ObservableFromFetch"
import ImplementationSearchResult from "../../api/Invitation/Model/ImplementationSearchResult"
import CompanyData from "../../api/Companies/CompanyModel/CompanyData"
import { Addresses } from "../OrderRequests/OrderRequestsModel/Addresses"

export interface EmailCheckResponse {
  IsEmailExists: boolean,
  AllowAdditionalRole: boolean,
  IsTCEmailExists: boolean
}

export function CompanyDataObservable(clientName: string, isActivateClient: boolean = false) {
  const requestBody: string = JSON.stringify({ clientName: clientName, IsActivateClient: isActivateClient })

  return ObservableFromFetch<CompanyData[]>("FFOrderClientFileMaintenance/GetInactiveClientInformation", requestBody)
}

export function ImplementationSearchObservable(companyName: string, isActivateClinic: boolean = false) {
  const requestBody: string = JSON.stringify({ CompanyName: companyName, IsActivateClinic: isActivateClinic })

  return ObservableFromFetch<ImplementationSearchResult[]>("FFOrderClinicFileMaintenance/GetClinicInformation", requestBody)
}

export function EmailCheck(email: string, link?: string) {
  const params = { EmailAddress: email }
  const requestBody: string = JSON.stringify(link ? { ...params, Link: link } : params)

  return ObservableFromFetch<EmailCheckResponse>("FFOrderClinicEnrollment/DoesEmailExists", requestBody)
}

export function CompanyNameCheck(name: string, link?: string, isClient?: boolean, implementationID?: number) {
  var params: object = { InstanceName: name }
  if (link) {
    params = { ...params, Link: link }
  }
  if (implementationID) {
    params = { ...params, ImplementationID: implementationID }
  }
  if (isClient) {
    params = { ...params, IsClient: isClient }
  }
  const requestBody: string = JSON.stringify(params)

  return ObservableFromFetch<Addresses | null>("FFOrderClinicEnrollment/DoesInstanceExists", requestBody)
}

export function CompanyCodeCheck(code: string, link?: string) {
  const requestBody: string = JSON.stringify({
    CompanyCode: code,
    Link: link
  })

  return ObservableFromFetch<string>("FFOrderClinicEnrollment/DoesCompanyCodeExists", requestBody)
}

export function UrlCheck(url: string) {
  const requestBody: string = new URLSearchParams({
    url: url
  }).toString()

  return ObservableFromFetch<string>("FFOrderClinicEnrollment/DoesURLExists?" + requestBody)
}

export function AllImplementationsGet(name: string) {
  const requestBody: string = new URLSearchParams({
    implementationName: name
  }).toString()

  return ObservableFromFetch<ImplementationSearchResult[]>("FFOrderClinicFileMaintenance/GetAllImplementationName?" + requestBody)
}
